import { useCallback, useMemo, useState } from "react";
import { PrivatePageHeader } from "views/components/headers"
import { ButtonPrivateHeader } from "views/components/controles/buttons";
import { FiltroIcon, MenuIcon } from "views/components/icons";
import { useMenuPrincipal } from "services/app";
import { useThemeQueries } from "views";
import { useHeaderStyles } from "views/components/headers/header-private-page/header-styles";
import { SetaCimaIcon } from "views/components/icons/seta-cima-icon";
import { IndicacaoRevendedoresHeaderPesquisa } from "./components/indicacao-revendedores-header-pesquisa/indicacao-revendedores-header-pesquisa";
import { IndicacaoRevendedoresListSearchProps } from "../indicacao-revendedores-list/indicacao-revendedores-list-search-props";

export interface IndicacaoRevendedoresHeaderProps {
    setSearchProps: React.Dispatch<React.SetStateAction<IndicacaoRevendedoresListSearchProps>>
}

export const IndicacaoRevendedoresHeader = ({
    setSearchProps,
    ...props
}: IndicacaoRevendedoresHeaderProps) => {
    const [openPesquisa, setOpenPesquisa] = useState(false);

    const { abrirMenu } = useMenuPrincipal();
    const { isMobile, theme } = useThemeQueries();
    const classes = useHeaderStyles();

    const leftArea = useCallback(
        () => (
            isMobile ?
                <ButtonPrivateHeader icon={<MenuIcon tipo="PRIVATE_HEADER"></MenuIcon>} tooltip="Menu" onClick={abrirMenu}></ButtonPrivateHeader> :
                null
        ),
        [isMobile, abrirMenu]
    );

    const rightArea = useCallback(
        () => (
            isMobile ? (
                <ButtonPrivateHeader
                    icon={
                        openPesquisa ? (
                            <SetaCimaIcon tipo="PRIVATE_HEADER"></SetaCimaIcon>
                        ) : (
                            <FiltroIcon tipo="PRIVATE_HEADER"></FiltroIcon>
                        )
                    }
                    tooltip={!openPesquisa ? "Pesquisar" : "Fechar Pesquisa"}
                    onClick={() => setOpenPesquisa(!openPesquisa)}
                ></ButtonPrivateHeader>
            ) :
                <ButtonPrivateHeader
                    className={classes.pesquisaBox}
                    text={!openPesquisa ? 'Filtros' : 'Fechar Filtros'}
                    icon={
                        openPesquisa ?
                            <SetaCimaIcon tipo="PRIVATE_HEADER" fill={theme.palette.primary.main}></SetaCimaIcon>
                            :
                            <FiltroIcon tipo="PRIVATE_HEADER" fill={theme.palette.primary.main}></FiltroIcon>}
                    tooltip={!openPesquisa ? "Pesquisar" : "Voltar"}
                    onClick={() => setOpenPesquisa(!openPesquisa)}
                ></ButtonPrivateHeader>
        ),
        [isMobile, openPesquisa, classes.pesquisaBox, theme.palette.primary.main, setOpenPesquisa]
    );

    const closePesquisaWrapper = useCallback(() => {
        setOpenPesquisa(false);
    }, [setOpenPesquisa]);

    const onPesquisar = useCallback(
        (props: IndicacaoRevendedoresListSearchProps) => {
            setSearchProps(props);
        },
        [setSearchProps]
    );

    const pesquisa = useMemo(() => (
        <IndicacaoRevendedoresHeaderPesquisa
            isOpened
            onCloseSearch={closePesquisaWrapper}
            onPesquisar={onPesquisar}
        />
    ), [closePesquisaWrapper, onPesquisar])

    const bottomArea = useCallback(() => (
        <IndicacaoRevendedoresHeaderPesquisa
            isOpened={openPesquisa}
            onCloseSearch={closePesquisaWrapper}
            onPesquisar={onPesquisar}
        />
    ), [closePesquisaWrapper, onPesquisar, openPesquisa])

    return (
        <>
            <PrivatePageHeader
                title="Indicação de Revendedores"
                leftArea={leftArea()}
                rightArea={isMobile ? rightArea() : pesquisa}
                bottomArea={isMobile ? bottomArea() : undefined}
            />
        </>
    );
};
